
import PropTypes from 'prop-types'
import React from 'react'
import './description.css'

const Description = props => <div className='InfoSheetDescription'>{props.children}</div>

Description.propTypes = {
  children: PropTypes.string.isRequired
}

Description.displayName = 'InfoSheet Description'

export default Description



// WEBPACK FOOTER //
// ./ui/InfoSheet/components/description.js